<div class="toast-message black-bg {{ type }}">
  <div class="media d-flex align-items-start spacing-16" [class.align-items-center]="!time">
    <div class="media-left">
      <div class="{{ type }} tick">
        <app-ce-icon
          [ngClass]="{ 'primary-100': type == 'cancel' }"
          [name]="toastIcons[type]"></app-ce-icon>
      </div>
    </div>
    <div
      class="media-body d-flex align-items-stretch justify-content-start flex-column spacing-16"
      [class.align-items-center]="!time">
      <div class="d-flex align-items-stretch justify-content-start flex-column spacing-4">
        <h4 class="h3-bold m-0">
          {{ name }} <span class="h3-reg">{{ message }}</span> {{ info }}
        </h4>
        <div class="time" [class.done]="time">
          <span class="h3-reg primary-50">{{ time }}</span>
        </div>
      </div>
    </div>
  </div>
  @if (State == 'default') {
    <div class="controls d-flex" [class.d-none]="!showControls">
      @if (primaryButton) {
        <app-buttons
          [active]="false"
          class="w-100"
          [disabled]="false"
          [shortcutKey]="false"
          label="Accept"
          type="button"
          IconType="add"
          size="small"
          Type="withoutIcon"></app-buttons>
      }
      @if (secondayButton) {
        <app-secondary-btns
          class="w-100"
          [active]="false"
          [disabled]="false"
          (click)="dismiss()"
          label="Dismiss"
          size="small"
          type="button"
          Type="withoutIcon"
          IconValue=""
          IconType="convert"></app-secondary-btns>
      }
    </div>
  }

  @if (State == 'accept') {
    <app-secondary-btns
      class="w-100"
      [active]="false"
      [disabled]="false"
      label="Redo"
      size="small"
      type="button"
      Type="leftIcon"
      IconValue=""
      IconType="refund"></app-secondary-btns>
  }
  @if (State == 'dismiss') {
    <app-secondary-btns
      class="w-100"
      [active]="false"
      [disabled]="false"
      label="Redo"
      size="small"
      type="button"
      Type="leftIcon"
      IconValue=""
      IconType="refund"></app-secondary-btns>
  }
</div>
